
  import { Vue, Component } from "vue-property-decorator";
  import ModalSectionsDivider from "@/components/modal/ModalSectionsDivider.vue";

  @Component({
    components: {
      ModalSectionsDivider,
    },
  })
  export default class ModalContent extends Vue {
  }
